<template>
  <div
    class="elevatorDetailsWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftMenuBox">
      <MenuListCom @getAllData="getAllData" />
    </div>
    <div class="rightContentBox">
      <div class="box commonWrap">
        <div class="commonTitle">
          <h4><span>1</span>累计门开关次数</h4>
        </div>
        <div class="commonContentBox">
          <ChartsCom :id="'myCharts'" :chartsData="doorSwitch" />
        </div>
      </div>
      <div class="box commonWrap">
        <div class="commonTitle">
          <h4><span>1</span>累计行梯次数</h4>
        </div>
        <div class="commonContentBox">
          <ChartsCom :id="'myCharts1'" :chartsData="move" />
        </div>
      </div>
      <div class="box commonWrap">
        <div class="commonTitle">
          <h4><span>1</span>累计行梯里程</h4>
        </div>
        <div class="commonContentBox">
          <ChartsCom :id="'myCharts2'" :chartsData="kilometre" />
        </div>
      </div>
      <div class="box commonWrap">
        <div class="commonTitle">
          <h4><span>1</span>累计运行时间</h4>
        </div>
        <div class="commonContentBox">
          <ChartsCom :id="'myCharts3'" :chartsData="times" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuListCom from "@/components/zixitong/elevatorSystem/MenuList";
import ChartsCom from "@/components/zixitong/elevatorSystem/Charts";
export default {
  components: {
    MenuListCom,
    ChartsCom,
  },
  data() {
    return {
      doorSwitch: {
        yData: [],
        data: [],
      },
      move: {
        yData: [],
        data: [],
      },
      kilometre: {
        yData: [],
        data: [],
      },
      times: {
        yData: [],
        data: [],
      },
    };
  },
  methods: {
    getAllData(data) {
      // console.log(data);
      this.doorSwitch.yData = [];
      this.doorSwitch.data = [];
      this.move.yData = [];
      this.move.data = [];
      this.kilometre.yData = [];
      this.kilometre.data = [];
      this.times.yData = [];
      this.times.data = [];
      data.doorSwitch.forEach((v) => {
        this.doorSwitch.yData.push(v.name);
        this.doorSwitch.data.push(v.value);
      });
      data.move.forEach((v) => {
        this.move.yData.push(v.name);
        this.move.data.push(v.value);
      });
      data.kilometre.forEach((v) => {
        this.kilometre.yData.push(v.name);
        this.kilometre.data.push(v.value);
      });
      data.times.forEach((v) => {
        this.times.yData.push(v.name);
        this.times.data.push(v.value);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.elevatorDetailsWrap {
  @include setFlexBetween;
  .leftMenuBox {
    width: 24%;
    height: 100%;
    overflow: hidden;
    background: #fff;
  }
  .rightContentBox {
    width: 74%;
    height: 96%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .box {
      width: 49%;
      height: 48%;
    }
  }
}
</style>